var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"table-card m-0 mt-3",attrs:{"data-aos":"fade-right","no-body":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }